import { useState, useEffect, useRef } from "react";
import PetInformation from "../PetInformation";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

const ConsentForm = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerDetails, petDetails } = routeState.state as ICustomerProfileState;

  const consentTexts = [
    "I, am the legal owner of the above-mentioned animal and authorized representative of the Owner.",
    "I hereby authorize and give permission for Treatment/anaesthetic surgery to be performed by the Registered Veterinary surgeon in the above-named clinic.",
    "I understand that all professional care and attention will be given to my Pet and recognize that there are attendant risks and possibilities of complication which I have discussed with the Veterinary Surgeon and thus release and indemnify the hospital and staff from any loss or claims which may result from any procedure performed. I also understand that no guarantee or assurance has been given by anyone as to the results that may be obtained.",
    "I understand that my responsibility to pay for these services and to comply with the conditions continues even in the event of the failure of my pet to respond or recover, or discharged (postoperative period) from the proposed procedure.",
    "I understand that in the event of discharge against medical advice, I will not hold the hospital or its staff responsible in any way for any mishap that may occur during the shifting or moving of the pet. I also understand that I will be solely responsible for the transportation cost incurred during the shifting of the pet and the hospital does not provide any such facility.",
    "I agree that all rights: including copyrights of all records: including radiographs: photographs CCTV recordings and drawings made shall remain the property of the clinic. In addition, I shall not make any recording, video or audio, take photographs or screenshots of video calls within restricted areas of the premises. In the event of any such activity, the hospital reserves the right to that information.",
    "I understand that the estimate of fees informed represents an estimated cost of the services anticipated in the care of my Pet. The actual cost may exceed the amount of the estimate. If an unanticipated procedure is to be carried out, the Veterinary Surgeon will make every attempt to notify me prior to the action. However, if the Veterinary Surgeon fails to reach me and the situation is critical to my Pet: I allow any necessary action to be taken. I agree to not bring any outside/home food for my pet during the admission period, and to visit only during stipulated visiting hours.",
    "In the unfortunate event of the pet's demise, I agree to collect the remains within 24 hours of being informed or the clinic reserves the right to send the remains for burial cremation, and I shall bear the costs of transport and crematorium charges.",
    "I hereby certify that I have read and fully understand the services to be provided and the costs of these services. I assume responsibility for all charges incurred by my Pet and agree to pay all expenses promptly and in full when my Pet is discharged or in the event of my Pet's demise. I agree to follow the rules and regulations laid down by the hospital in regard to visiting the pet when it is admitted.",
    "I hereby authorize the veterinarian to examine, prescribe for, or treat the above-described patient/pet.",
    "The visiting and discharge time is between 4.30 PM to 6.30 PM and each visit is limited to 15 minutes. I will refrain from interacting with other sick pets on my visits.",
    "I have read and understood this consent form. I consent to the proposed procedures.",
  ];

  const text = `I ${customerDetails?.name} am the owner/authorised agent of the pet ${petDetails?.name} and have the authority to execute this consent. I authorize Vetic Pet Clinic and its staff to examine, prescribe for, or treat the above-described patient/pet.`;

  return (
    <div>
      <div>
        <PetInformation />
      </div>
      <p className="py-2 font-semibold pt-2">Treatment Consent:</p>

      <DynamicTextarea key={0} initialValue={text} />
      {consentTexts.map((text, index) => (
        <DynamicTextarea key={index} initialValue={text} />
      ))}

      <div className="mt-8 flex justify-between">
        <p>Date</p>
        <p>Signature of Pet Owner</p>
      </div>
    </div>
  );
};

const DynamicTextarea = ({ initialValue }: { initialValue: string }) => {
  const [value, setValue] = useState(initialValue);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div className="print-textarea">
      {/* Show textarea for normal view */}
      <textarea
        ref={textareaRef}
        className="w-full border p-2 print:hidden text-xs resize-none scrollbar-thin"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onInput={adjustHeight}
      />
      {/* Show div in print mode to prevent text cut-off */}
      <div className="hidden print:block  w-full print:border-none p-2 text-xs whitespace-pre-wrap">{value}</div>
    </div>
  );
};

export default ConsentForm;
